import { Component } from '@angular/core';
import { ModalService } from '../../../../../shared/modal/modal.service';
import { NavbarService } from '../../../../../shared/navbar/navbar.service';
import { MenuService } from '../../../../../shared/menu/menu.service';

@Component({
  selector: 'app-historico',
  standalone: true,
  imports: [],
  templateUrl: './historico.component.html',
  styleUrl: './historico.component.scss'
})
export class HistoricoComponent {
constructor(
    private readonly modalService: ModalService,
    private readonly navbarService: NavbarService,
    private readonly menuService: MenuService
  ) {
    navbarService.setTitle('Histórico');
    menuService.setSelected({
      icon: 'history',
      label: 'Histórico',
      route: '/admin/historico-aluno',
      checked: true,
    });
  }
}
